import { useProperty, useTranslation } from '@eti/providers';
import type { BrandedFare } from '@eti/schema-types';
import Feature from '../Feature';
import { getPersonalAndCabinBaggageInfo } from '../../utils';
import {
  personalAndCabinBaggageDefaultShowType,
  personalAndCabinBaggageShowTypePair,
} from '../constants';
import CabinBaggageFeature from './CabinBaggageFeature';

interface PersonalItemAndCabinBaggageFeatureProps {
  shouldShowNotIncludedProducts: boolean;
  isPersonalItemIncluded: boolean;
  brandedFareData: BrandedFare;
}

const PersonalItemAndCabinBaggageFeature = ({
  shouldShowNotIncludedProducts,
  isPersonalItemIncluded,
  brandedFareData,
}: PersonalItemAndCabinBaggageFeatureProps) => {
  const { p } = useProperty();
  const { t } = useTranslation();
  const personalAndCabinBaggageShowType = String(
    p('BrandedFares.PersonalAndCabinBaggage.ShowType'),
  ).toUpperCase();
  const cabinBaggageTripSummary = brandedFareData?.cabinBaggageTripSummary;

  if (personalAndCabinBaggageShowType === personalAndCabinBaggageDefaultShowType) {
    const personalItemText = isPersonalItemIncluded
      ? t('BrandedFares.PersonalBaggageIncluded.Text')
      : t('BrandedFares.PersonalBaggageNotIncluded.Text');

    return (
      <>
        <Feature
          isIncluded={isPersonalItemIncluded}
          key={`${brandedFareData.id}${personalItemText}`}
          label={personalItemText}
        />
        <CabinBaggageFeature
          brandedFareData={brandedFareData}
          shouldShowNotIncludedProducts={shouldShowNotIncludedProducts}
        />
      </>
    );
  }

  if (
    cabinBaggageTripSummary &&
    personalAndCabinBaggageShowType === personalAndCabinBaggageShowTypePair
  ) {
    const { isIncluded, personalAndCabinText } = getPersonalAndCabinBaggageInfo(
      isPersonalItemIncluded,
      t,
      cabinBaggageTripSummary,
    );

    return (
      <Feature
        isIncluded={isIncluded}
        key={`${brandedFareData.id}${personalAndCabinText}`}
        label={personalAndCabinText}
      />
    );
  }

  return null;
};

export default PersonalItemAndCabinBaggageFeature;
